import React, { Component, createRef } from "react";

// Helper
import { checkCookie } from "../../Helper/Cookies";
import { apiFetch } from "../../Helper/Api";

// Components
import Header from "../../components/Header/Header";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

// Properties
const properties = require("../../properties.json");

class AllCourses extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    globalFilter: null,
    data: [],
  };

  getCourses = () => {
    apiFetch("/courses")
      .then((data) => this.setState({ data }))
      .catch((error) => console.error("Error:", error));
  };

  deleteCourse = (id) => {
    var _this = this;
    var con = window.confirm("هل أنت متأكد من أنك تريد حذف هذه الدورة وكل محتواها؟");
    if (con) {
      apiFetch(`/courses/${id}`, { method: "DELETE" })
        .then(() => {
          _this.toast.current.show({ severity: "success", summary: "تمت العملية", detail: "تم الحذف بنجاح" });
          this.getCourses();
        })
        .catch((error) => {
          console.error("Error:", error);
          _this.toast.current.show({ severity: "error", summary: "لم تتم العملية", detail: error.message || "خطأ في الإتصال" });
        });
    }
  };

  componentDidMount() {
    document.title = properties.site_name + " | الدورات التعليمية";

    if (!checkCookie("name")) {
      window.localStorage.removeItem("currentTeacher");
      window.location.href = `/`;
    }

    this.getCourses();
  }

  render() {
    const header = (
      <div className="table-header">
        كل الدورات
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => this.setState({ globalFilter: e.target.value })}
            placeholder="بحث في الدورات"
          />
        </span>
        <Button
          label="دورة جديدة"
          icon="pi pi-plus"
          className="p-button-secondary"
          onClick={() => (window.location.href = "/courses/add")}
        />
      </div>
    );

    const actionBodyTemplate = (rowData) => (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-secondary p-ml-2"
          onClick={() => (window.location.href = `/courses/edit/${rowData.id}`)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={() => this.deleteCourse(rowData.id)}
        />
      </React.Fragment>
    );

    return (
      <>
        <Header pageName="الدورات التعليمية" />

        <Toast ref={this.toast}></Toast>

        <div className="content">
          <div className="container">
            <div className="card">
              <Card title="كل الدورات">
                <DataTable
                  header={header}
                  sortable
                  globalFilter={this.state.globalFilter}
                  className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                  value={this.state.data}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  emptyMessage="لا يوجد دورات بعد"
                >
                  <Column filter sortable field="title" header="إسم الدورة"></Column>
                  <Column field="description" header="الوصف"></Column>
                  <Column header="تعديل / حذف" body={actionBodyTemplate}></Column>
                </DataTable>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AllCourses;
